import * as React from "react";
const SvgFiRrCube = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cube_svg__a)">
      <path
        fill="#062147"
        d="M20.527 4.217 14.5.737a5.01 5.01 0 0 0-5 0l-6.027 3.48a5.01 5.01 0 0 0-2.5 4.33v6.96a5.02 5.02 0 0 0 2.5 4.33l6.027 3.48a5.01 5.01 0 0 0 5 0l6.027-3.48a5.02 5.02 0 0 0 2.5-4.33v-6.96a5.01 5.01 0 0 0-2.5-4.33M10.5 2.47a3 3 0 0 1 3 0l6.027 3.479q.229.145.429.33l-6.193 3.575a3.53 3.53 0 0 1-3.526 0L4.044 6.279q.199-.185.429-.33zM4.473 18.105a3.01 3.01 0 0 1-1.5-2.6V8.547q.01-.271.07-.535l6.194 3.575a5.5 5.5 0 0 0 1.763.635v9.569a3 3 0 0 1-.5-.206zm16.554-2.6a3.01 3.01 0 0 1-1.5 2.6l-6.027 3.48q-.241.126-.5.206v-9.57a5.5 5.5 0 0 0 1.763-.634l6.193-3.575q.06.265.07.535z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cube_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCube;
